import { render, staticRenderFns } from "./todayTab.vue?vue&type=template&id=064bc7b5&"
import script from "./todayTab.vue?vue&type=script&lang=js&"
export * from "./todayTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports